import { render, staticRenderFns } from "./ExtraServiceDetailsList.vue?vue&type=template&id=ed02886e"
import script from "./ExtraServiceDetailsList.vue?vue&type=script&lang=ts"
export * from "./ExtraServiceDetailsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports